(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TkbTransferDetailController', TkbTransferDetailController);

    TkbTransferDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TkbTransfer', 'Customer'];

    function TkbTransferDetailController($scope, $rootScope, $stateParams, previousState, entity, TkbTransfer, Customer) {
        var vm = this;

        vm.tkbTransfer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('bozorakaAdminApp:tkbTransferUpdate', function(event, result) {
            vm.tkbTransfer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
